(function($) {
  
  const API = 'https://rnd.mypubs.ru/api.php';

  const Command = {
    RATING: 'rating',
    LOAD: 'load',
    ADD: 'add',
    DELETE: 'delete'
  };  

  const Error = {
    ACCESS_DENIED: -1,
    PARAM_FAIL: -2,
    NOT_FOUND: -3,
    BANNED: -4,
    INVALID_EMAIL: -5,
    INVALID_NAME: -6,
    EMPTY_CONTENT: -7,
    TIMEOUT: -8,
    LARGE_REVIEW: -9,
    ALREADY_EXISTS: -10
  };

  var debug = false;
  var fp;

  var formatter = new Intl.DateTimeFormat("ru", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  });

  loadUrlReviews = function () {
    var url = location.href.replace(location.hash, "");
    var container = $('#reviews');
    var loader = $('.items-loading');
    loader.show();
    $.post(API, {
        url,
        cmd: Command.LOAD
      })
      .done(function(data) {
        if (debug) {
          console.log(data);
        }        
        if (data < 0) {
          showError(data);
          return;
        }
        var list = JSON.parse(data);
        if (list.length > 0) {
          addAnswers(list);
          addConfirms();
        }
      }).always(function () {
        loader.hide();
      });
  }

  setFP = function(data) {
    fp = data;
  }

  setDebug = function(data) {
    debug = data;
  }  

  function confirmDelete(id) {
    var container = $(`#review-${id}`).find('.review-delete');
    container.html('<a href="#" id="do-delete">Удалить</a> <a href="#" id="cancel-delete">Отмена</a>');
    container.find('#do-delete').on('click', function() {
      deleteReview(id);
      return false;
    });
    container.find('#cancel-delete').on('click', function() {
      container.html('<a href="#" class="confirm-delete"><i class="fa-solid fa-trash-can"></i></a>');
      addConfirms();
      return false;
    });
  }

  function deleteReview(id) {
    var url = location.href.replace(location.hash, "");
    var data = {
      id,
      fp
    };
    $.post(API, {
        cmd: Command.DELETE,
        url,
        data
      })
      .done(function(data) {
        if (debug) {
          console.log(data);
        }        
        if (data < 0) {
          showError(data);
          return;
        }
        var article = $(`#review-${id}`);
        article.find('.review-delete').hide();
        var body = article.find('p');
        body.html('<i>Отзыв удалён</i>');
      }).fail(function (e) {
        var info = $(`<div class="alert-error"><strong>ОШИБКА:</strong> не удалось удалить отзыв</div>`);
        $('#reviews').append(info);
        info.fadeOut(3500).queue(function() {
          $(this).remove();
        });
      });
  }

  function addReview(comment, author, email, rating) {
    var url = location.href.replace(location.hash, "");
    var data = {
      comment,
      author,
      email,
      rating,
      fp
    };
    $.post(API, {
        cmd: Command.ADD,
        url,
        data
      })
      .done(function(data) {
        if (debug) {
          console.log(data);
        }        
        if (data < 0) {
          showError(data);
          return;
        }
        $('#review-text').val('');        
        generateReview(JSON.parse(data));
        resetForm();
        addConfirms();
      }).fail(function(e) {
        var info = $(`<div class="alert-error"><strong>ОШИБКА:</strong> не удалось отправить отзыв</div>`);
        $('#reviews').append(info);
        info.fadeOut(3500).queue(function() {
          $(this).remove();
        });
      });
  }

  function showError(code) {
    var message;
    switch (Number(code)) {
      case Error.ACCESS_DENIED:
        message = 'Доступ запрещён';
        break;
      case Error.PARAM_FAIL:
        message = 'Неверные параметры';
        break;
      case Error.NOT_FOUND:
        message = 'Отзыв не найден';
        break;
      case Error.BANNED:
        message = 'Действие ограничено, обратитесь к автору сайта';
        break;
      case Error.INVALID_EMAIL:
        message = 'Некорректная эл. почта';
        break;
      case Error.INVALID_NAME:
        message = 'Некорректное имя';
        break;
      case Error.EMPTY_CONTENT:
        message = 'Пустое поле ввода';
        break;
      case Error.TIMEOUT:
        message = 'Время на выполнение действия вышло';
        break;
      case Error.LARGE_REVIEW:
        message = 'Слишком длинный отзыв';
        break;
      case Error.ALREADY_EXISTS:
        message = 'Вы уже оставляли отзыв для этого заведения, повторная публикация запрещена';
        break;
      default:
        message = `Код (${code})`;
        break;
    }
    var info = $(`<div class="alert-error"><strong>ОШИБКА:</strong> ${message}</div>`);
    $('#reviews').append(info);
    info.fadeOut(3500).queue(function() {
      $(this).remove();
    });
  }

  function resetForm() {
    $('#review-text').val('');
    var cookies = $('#review-save-email').prop('checked');
    if (!cookies) {
      $('#review-name').val('');
      $('#review-email').val('');
    }
  }

  function addForm() {
    $('#review-form').on('submit', function(e) {
      e.preventDefault();
      var comment = $('#review-text').val().trim();
      var author = $('#review-name').val().trim();
      var email = $('#review-email').val().trim();
      var rating = $('#review-rating').val();
      var cookies = $('#review-save-email').prop('checked');
      if (!validate(comment, author, email)) {
        return;
      }
      if (cookies) {
        var age = {
          'max-age': '604800'
        };
        setCookie('author', author, age);
        setCookie('email', email, age);
      }          
      addReview(comment, author, email, rating);
      addConfirms();
    });
    ThumbmarkJS.getFingerprint().then(function(fingerprint) {
      fp = fingerprint;
    });
  }

  function addConfirms() {
    $('.confirm-delete').off('click');
    $('.confirm-delete').on('click', function () {
      var article = $(this).parent().parent();
      var id = article.attr('id').split('-')[1];
      confirmDelete(id);
      return false;
    });
  }

  function validate(comment, author, email) {
    var errors = 0;
    $('#review-text').removeClass('is-invalid');
    $('#review-name').removeClass('is-invalid');
    $('#review-email').removeClass('is-invalid');
    if (comment.length === 0) {
      $('#review-text').addClass('is-invalid');
      errors++;
    }
    if (author.length === 0) {
      $('#review-name').addClass('is-invalid');
      errors++
    }
    if (email.length === 0) {
      $('#review-email').addClass('is-invalid');
      errors++;
    }
    return errors === 0;
  }

  function addAuthor() {
    var author = getCookie('author');
    var email = getCookie('email');
    if (author) {
      $('#review-name').val(author);
    }
    if (email) {
      $('#review-email').val(email);
    }
    if (author || email) {
      $('#review-save-email').prop('checked', true);
    }
  }

  function addAnswers(list) {
    var parent = $('#reviews');
    list.forEach(item => {
      if (item.body.length > 0) {
        generateReview(item);
      }
    });
  }

  function pad(n) {
    return `${Math.floor(Math.abs(n))}`.padStart(2, '0');
  }

  function getTimezoneOffset(date) {
    var offset = -date.getTimezoneOffset();
    var diff = offset >= 0 ? '+' : '-';
    return diff + pad(offset / 60) + ':' + pad(offset % 60);
  };

  function toISOStringWithTimezone(date) {
    return date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds()) +
      getTimezoneOffset(date);
  };

  function generateReview(comment) {
    var date = new Date(comment.date * 1000);
    var url = location.href.replace(location.hash, "");
    var article = $(`<article class="review-item" id="review-${comment.id}"></article>`);
    var header = $(`<div class="review-head"></div>`);
    var author = $(`<span class="review-author">${comment.name}</span>`);
    var score = $(`<span class="review-score">${window.mypubs.stars(comment.rating)} ${comment.rating.toFixed(1)}</span>`);
    var text = $(`<p class="muted-text mb-0">${comment.body}</p>`);
    var trash = $(`<span class="review-delete"><a href="#" class="confirm-delete"><i class="fa-solid fa-trash-can"></i></a></span>`);
    header.append(author);
    header.append(score);
    var diff = (Date.now() - date) / 1000;
    if (diff <= DeletePeriod && comment.body.length > 0) {
      article.append(trash);
      trash.delay(DeletePeriod * 1000).queue(function() {
        $(this).remove();
      });
    }
    article.append(header);
    article.append(text);
    $('#reviews').append(article);
  }

  function plural(forms, count) {
    let index;
    if (count % 10 === 1 && count % 100 !== 11) {
      index = 0;
    } else if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
      index = 1;
    } else {
      index = 2;
    }
    return forms[index] || '';
  }

  var container = $('#reviews');
  if (container) {
    loadUrlReviews();
    addForm();
    addAuthor();
  }

})(jQuery);